package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.image.SupportedImageFormats
import fr.manyverse.app.domain.model.ImageData

/**
 * Validator for image data.
 * Validates size limits and MIME types for character avatar images.
 */
object ImageValidator {
    private const val MAX_SIZE_BYTES = 20 * 1024 * 1024 // 20MB

    /**
     * Validates image data for upload.
     * @param imageData The image data to validate
     * @return Result.success if valid, Result.failure with ValidationError if invalid
     */
    fun validate(imageData: ImageData): Result<Unit> {
        if (imageData.bytes.size > MAX_SIZE_BYTES) {
            return Result.failure(
                ValidationError("Image exceeds maximum size of 20MB")
            )
        }
        if (imageData.mimeType !in SupportedImageFormats.mimeTypes) {
            return Result.failure(
                ValidationError("Invalid image type. Allowed: JPEG, PNG, WebP")
            )
        }
        return Result.success(Unit)
    }
}
